import { formatDate, formatMoney } from '@itarget/shared'
import { Box, Typography } from '@material-ui/core'
import Loading from '../../Loading'
import NoData from '../../NoData'
import Transaction from '../../Transaction'
import { useClasses } from './useClasses'
import { useGroup } from './useGroup'
import { useTranslation } from './useTranslation'

export const Group = () => {
  const { groupCollection, isAllMovementsLoaded } = useGroup()
  const translation = useTranslation()
  const classes = useClasses()
  const empty = !groupCollection.length

  return (
    <Box className={classes.root}>
      {isAllMovementsLoaded && empty && <NoData />}
      {!empty &&
        groupCollection.map(({ date, balance, transactions }, index) => {
          const keyGroupStatement = `${index}_group_statements`
          return (
            <Box key={keyGroupStatement} display="flex" flexDirection="column">
              <Box
                display="flex"
                alignItems="center"
                flexDirection="row"
                justifyContent="space-between"
              >
                <Typography className={classes.date}>
                  {`${formatDate.getDay(date)} de ${formatDate.monthInFull(date)} ${formatDate.format(date, 'YYYY')}`}
                </Typography>
                {/* <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-end"
                >
                  <Typography className={classes.balanceLabel}>
                    {translation.dailyBalance}
                  </Typography>
                  <Typography className={classes.balance}>
                    R$ {formatMoney.toReal(balance)}
                  </Typography>
                </Box> */}
              </Box>
              <Box>
                {transactions.map(
                  (
                    {
                      description,
                      modality,
                      status,
                      points,
                      transactionDate,
                      transactionType,
                    },
                    index,
                  ) => {
                    const keyTransactionStatement = `${keyGroupStatement}_${index}_transaction_statements`
                    return (
                      <Transaction
                        key={keyTransactionStatement}
                        points={points}
                        status={status}
                        modality={modality}
                        description={description}
                        transactionDate={transactionDate}
                        transactionType={transactionType}
                      />
                    )
                  },
                )}
              </Box>
            </Box>
          )
        })}
      {!isAllMovementsLoaded && <Loading />}
    </Box>
  )
}
